import { makeStyles } from '@material-ui/core/styles';

const ITEM_HEIGHT = 38;
// https://mui.com/customization/palette/
export const useStyles = makeStyles((theme) => ({
  introMenu: {
    maxHeight: ITEM_HEIGHT * 15,
    width: 350,
    backgroundColor: `${(theme as any).palette.background.dark1}`,
  },
  textField: {
    fontSize: '1rem',
    width: '150px',
  },
  labelInput: {
    transform: 'scale(1) translate(-0%, 0%)',
  },
  /** Same typeface as dialog body (“Please record HCPCS”); larger for visibility. */
  saveError: {
    color: theme.palette.error.main,
    fontFamily: theme.typography.fontFamily,
    fontSize: '1.25rem',
    fontWeight: 500 as const,
    lineHeight: 1.4,
    margin: 0,
    marginRight: 'auto',
    flex: 1,
    minWidth: 0,
    paddingRight: theme.spacing(2),
  },
  submitFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '100%',
    marginTop: theme.spacing(1),
  },
}));
